import { colorPrimaryBase } from '@mediahuis/chameleon-theme-wl';
export var base = {
  statusColors: {
    active: '#49e305',
    inactive: '#e20714'
  },
  chatbotBgColor: colorPrimaryBase
};
export default base;